/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderCollectiveSourcingSourcingTypes = 'Open' | 'Closed';

export const TenderCollectiveSourcingSourcingTypes = {
    Open: 'Open' as TenderCollectiveSourcingSourcingTypes,
    Closed: 'Closed' as TenderCollectiveSourcingSourcingTypes
};

